<template>
  <div class="ui mini modal" ref="modal">
    <!--Mismo caso-->
    <i class="close icon" @click="$emit('close')"></i>
    <div class="content">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header fdinpro default-header-green">
          {{ $t("code re-send") }}
        </h3>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("date") }}</label>
          <label class="disabled">{{
            request.create_date
              | formatDate(enterprise_setup.simple_date_format)
          }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{
            $t("customer name")
          }}</label>
          <label class="disabled">{{ request.setup.customer_name }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("series") }}</label>
          <label class="disabled">{{
            request.setup.card_or_notebook_serial
          }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("product") }}</label>
          <label class="disabled">{{ $t(request.setup.product_type) }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("gpu") }}</label>
          <label class="disabled">{{ request.setup.gpu_type }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("brand") }}</label>
          <label class="disabled">{{ request.setup.brand }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{
            $t("bill or ticket number")
          }}</label>
          <label class="disabled">{{
            request.setup.bill_or_ticket_number
          }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("email") }}</label>
          <input
            type="text"
            name="correo_electronico"
            placeholder=""
            v-model="request.setup.customer_email"
          />
        </div>
        <div
          class="ui fluid button modal-button-green"
          tabindex="0"
          @click="do_request"
        >
          {{ $t("resend") }}
        </div>
        <!-- <pre>{{ request }}</pre> -->
        <div class="ui error message"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  success_toast,
} from "@/utils";
import filters from "@/filters";
// import { local_api, error_toast, enterprise_setup, api_host } from "@/utils";
// import vueFilePond from "vue-filepond";
// import uuid from "uuid/v4";
// Import FilePond styles
// import "filepond/dist/filepond.min.css";

// const FilePond = vueFilePond();

export default {
  components: {
    // FilePond,
  },
  filters: filters,
  name: "",
  props: {},
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          correo_electronico: ["empty", "email"],
        },
      });
    },
  },
  data() {
    return {
      request: {
        setup: { customer_email: "" },
      },
      // api_host: api_host,
    };
  },
  methods: {
    do_request() {
      let vm = this;
      let isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        local_api(vm, "post", "/nworkforce_nvidia/do-resend", {
          e: vm.request.setup.customer_email,
          u: vm.request.request_id,
        })
          .then(function(r) {
            vm.$emit("request_resent", r);
            success_toast(vm.$t("request sent"));
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch(function(err) {
            error_toast(err);
          });
      }
    },
    show(request) {
      let vm = this;
      vm.request = request;
      window.jQuery(vm.$refs.modal).modal("show");
    },
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
